var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreYouSure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4997,
    cy: 50.4997,
    r: 49.9997,
    fill: "#EBF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1506 20.4947L93.1703 87.3082C94.8967 90.424 93.7663 94.3473 90.6454 96.0709C89.6886 96.5994 88.613 96.8766 87.5195 96.8766H13.4802C9.91371 96.8766 7.02246 93.99 7.02246 90.4292C7.02246 89.3374 7.30014 88.2635 7.82946 87.3082L44.8491 20.4947C46.5755 17.3788 50.505 16.2502 53.6258 17.9739C54.688 18.5605 55.563 19.4342 56.1506 20.4947ZM48.6889 46.1523C47.6884 46.1523 46.8773 46.9634 46.8773 47.9639V69.7029C46.8773 70.7034 47.6884 71.5145 48.6889 71.5145H52.312C53.3125 71.5145 54.1236 70.7034 54.1236 69.7029V47.9639C54.1236 46.9634 53.3125 46.1523 52.312 46.1523H48.6889ZM48.6889 78.7608C47.6884 78.7608 46.8773 79.5719 46.8773 80.5724V84.1956C46.8773 85.1961 47.6884 86.0071 48.6889 86.0071H52.312C53.3125 86.0071 54.1236 85.1961 54.1236 84.1956V80.5724C54.1236 79.5719 53.3125 78.7608 52.312 78.7608H48.6889Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSure);
export default __webpack_public_path__ + "static/media/are-you-sure.0767db109a81af5c9c549fd96eb07ea6.svg";
export { ForwardRef as ReactComponent };